<template>
  <div class="w-full overflow-hidden">
    <div class="surface-50 py-5">
      <div class="surface-0 px-4 border-1 border-200 py-8 md:px-6 lg:px-8 md:mx-5 xl:mx-8">
        <div
          v-if="hasAuthors || publicationDate"
          class="text-600 text-sm mb-3 flex flex-wrap align-items-center gap-2"
        >
          <div v-if="hasAuthors" class="font-bold inline-flex align-items-center">
            <Authors
              v-if="item?.person_id"
              :where="{
                id: { $eq: item.person_id },
              }"
            />
            <Authors
              v-else
              :where="{
                id: { $in: item.authors },
              }"
            />
          </div>
          <div v-if="publicationDate" class="flex align-items-center gap-2">
            <i
              v-if="hasAuthors"
              class="pi pi-circle-fill green"
              style="font-size: 0.5rem"
              aria-hidden="true"
            />
            <time :datetime="publicationDate" class="text-500">
              {{ publicationDate }}
            </time>
          </div>
        </div>

        <div
          v-if="item?.supervisors && item.supervisors.length"
          class="text-600 text-sm mb-3 flex flex-wrap align-items-center gap-1"
        >
          <span>{{ item.supervisors.length == 1 ? 'Supervisor:' : 'Supervisors:' }}</span>
          <div class="font-bold inline-flex align-items-center">
            <Authors
              :where="{
                id: { $in: item.supervisors },
              }"
            />
          </div>
        </div>

        <div
          v-if="item.name"
          class="border-purple-800 font-medium text-2xl p-3 mb-3 text-900"
          style="border-left: 8px solid"
        >
          {{ item?.name }}
        </div>
        <DeferredContent v-if="item?.img && item.path != 'resources/student-research'">
          <img
            :src="getImgPath(item.img)"
            :alt="item.name || ''"
            class="block h-auto md:h-25rem w-full"
            style="object-fit: contain"
          />
        </DeferredContent>
        <div
          v-if="item?.body"
          v-html="item.body"
          class="line-height-3 text-sm text-800 mb-3 px-3 md:px-4"
        ></div>
        <slot name="content" :item="item" />
        <Navigation />
        <div
          class="flex justify-content-between align-items-center flex-wrap surface-100 mt-5 p-5 border-round"
        >
          <div class="text-lg font-light">Share This Story, Choose Your Platform!</div>
          <div class="flex gap-2">
            <a
              :href="`https://www.facebook.com/sharer/sharer.php?u=${URL}`"
              target="_blank"
              class="cursor-pointer"
            >
              <i class="pi pi-facebook border-circle text-600" />
            </a>
            <a
              :href="`https://twitter.com/share?url=${URL}`"
              target="_blank"
              class="cursor-pointer"
            >
              <i class="pi pi-twitter border-circle text-600" />
            </a>
            <a
              :href="`https://www.reddit.com/submit?url=${URL}`"
              target="_blank"
              class="cursor-pointer"
            >
              <i class="pi pi-reddit border-circle text-600" />
            </a>
            <a
              :href="`https://www.linkedin.com/shareArticle?mini=true&url=${URL}`"
              target="_blank"
              class="cursor-pointer"
            >
              <i class="pi pi-linkedin border-circle text-600" />
            </a>
            <a
              :href="`https://api.whatsapp.com/send?text=${URL}`"
              target="_blank"
              class="cursor-pointer"
            >
              <i class="pi pi-whatsapp border-circle text-600" />
            </a>
            <a
              :href="`https://pinterest.com/pin/create/button/?url=${URL}`"
              target="_blank"
              class="cursor-pointer"
            >
              <i class="pi pi-pinterest border-circle text-600" />
            </a>
            <a :href="`mailto:?body=${URL}`" target="_blank" class="cursor-pointer">
              <i class="pi pi-envelope border-circle text-600" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute()
const reqUrl = useRequestURL()

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

const hasAuthors = computed(() => Boolean(props.item?.person_id || props.item?.authors?.length))
const publicationDate = computed(() => props.item?.date ?? props.item?.graduation_date)

const getImgPath = (uuid) => {
  return uuid ? `/media/${uuid}.webp` : '/images/heading_image2.webp'
}

const URL = ref(encodeURIComponent(reqUrl.origin + route.fullPath))
</script>

<style scoped></style>
